// extracted by mini-css-extract-plugin
export default {"Modal_Text":"Share_Modal_Text__k3vDd","Share_Modal":"Share_Share_Modal__tTPsO","Modal_Actions":"Share_Modal_Actions__eyKY2"};